import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const VARIANTS = {
  up: { initial: { opacity: 0, y: 36, scale: 0.985 }, animate: { opacity: 1, y: 0, scale: 1 } },
  depth: { initial: { opacity: 0, y: 22, scale: 0.94, rotateX: 5 }, animate: { opacity: 1, y: 0, scale: 1, rotateX: 0 } },
  fade: { initial: { opacity: 0 }, animate: { opacity: 1 } },
};

export default function FadeIn({ children, delay = 0, className = "", variant = "up" }) {
  const v = VARIANTS[variant] || VARIANTS.up;
  return (
    <motion.div
      initial={v.initial}
      whileInView={v.animate}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
      style={{ transformPerspective: 900 }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Parallax({ children, speed = 0.4, className = "" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [44 * speed, -44 * speed]);
  return (
    <motion.div ref={ref} style={{ y }} className={className}>
      {children}
    </motion.div>
  );
}

export function SectionHeading({ label, title, sub, align = "left" }) {
  const centered = align === "center";
  return (
    <Parallax speed={0.3}>
      <FadeIn className={centered ? "text-center" : ""}>
        <p className="gold-label mb-5">{label}</p>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-ivory leading-[1.1] max-w-3xl mx-auto" style={centered ? {} : { marginLeft: 0 }}>
          {title}
        </h2>
        {sub && (
          <p className={`mt-6 text-base md:text-lg text-ivory/60 font-light leading-relaxed max-w-2xl ${centered ? "mx-auto" : ""}`}>
            {sub}
          </p>
        )}
      </FadeIn>
    </Parallax>
  );
}
